import * as types from "../types";

const initialState = {
  AmbassadorReferrals: [],
  totalAmbassadorRecords: null,
  BtReferrals: [],
  totalBtRecords: null,
  DirectReferrals: [],
  totalDirectRecords: null,
  loading: false,
  isAmbassadorLoading: false,
  isBtLoading: false,
  isDirectLoading: false,
  error: null,
};

export const referralsReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.REFERRAL_AMBASSADOR_REQUEST:
      return {
        ...state,
        isAmbassadorLoading: true,
        error: null,
      };

    case types.REFERRAL_AMBASSADOR_SUCCESS:
      return {
        ...state,
        isAmbassadorLoading: false,
        AmbassadorReferrals: action.payload?.results || [],
        totalAmbassadorRecords: action.payload?.count || 0,
      };

    case types.REFERRAL_AMBASSADOR_FAILURE:
      return {
        ...state,
        isAmbassadorLoading: false,
        error: action.payload,
      };

    case types.REFERRAL_BT_REQUEST:
      return {
        ...state,
        isBtLoading: true,
        error: null,
      };

    case types.REFERRAL_BT_SUCCESS:
      return {
        ...state,
        isBtLoading: false,
        BtReferrals: action.payload?.results,
        totalBtRecords: action.payload?.count || 0,
      };

    case types.REFERRAL_BT_FAILURE:
      return {
        ...state,
        isBtLoading: false,
        error: action.payload,
      };

    case types.REFERRAL_DIRECT_REQUEST:
      return {
        ...state,
        isDirectLoading: true,
        error: null,
      };

    case types.REFERRAL_DIRECT_SUCCESS:
      return {
        ...state,
        isDirectLoading: false,
        DirectReferrals: action.payload?.results,
        totalDirectRecords: action.payload?.count || 0,
      };

    case types.REFERRAL_DIRECT_FAILURE:
      return {
        ...state,
        isDirectLoading: false,
        error: action.payload,
      };

    case types.LOGOUT:
      return initialState;

    default:
      return state;
  }
};
